module.exports = __webpack_public_path__ + "static/media/mode-550.902c4264.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-550.svg
// module id = 1075
// module chunks = 2